import { render, staticRenderFns } from "./FCCDB.vue?vue&type=template&id=2c7da4f0&scoped=true"
import script from "./FCCDB.vue?vue&type=script&lang=js"
export * from "./FCCDB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7da4f0",
  null
  
)

export default component.exports